import React from 'react'

import ContactPhoneSection from '../../../react4xp/components/ContactPhoneSection'

function ContactPhonePart({ title, phones }) {
    return (
        <ContactPhoneSection
            title={title}
            phones={phones}
        />
    )
}

export default (props) => <ContactPhonePart {...props} />
